import { GroupByDate } from '@/models/app-common/app-common.model';
import { formatUnixToString } from '@marfa/bo-utils';

export enum ReportTableHeaders {
  AGGREGATE_DATE = 'aggregateDate',
  CURRENCY = 'currency',
  GAME_PRODUCER = 'gameProducer',
  BETS_BONUS_SUM = 'betsBonusSum',
  BETS_SUM = 'betsSum',
  WINS_BONUS_SUM = 'winsBonusSum',
  WINS_SUM = 'winsSum',
  REVENUE = 'revenue',
  TOTAL = 'total',
}

export type TableColumn = {
  prop: string;
  width?: number;
}

export const MGA_REPORT_TABLE_COLUMNS: TableColumn[] = [
  { prop: ReportTableHeaders.CURRENCY },
  { prop: ReportTableHeaders.GAME_PRODUCER, width: 160 },
  { prop: ReportTableHeaders.BETS_BONUS_SUM },
  { prop: ReportTableHeaders.BETS_SUM },
  { prop: ReportTableHeaders.WINS_BONUS_SUM },
  { prop: ReportTableHeaders.WINS_SUM },
  { prop: ReportTableHeaders.REVENUE },
];

export type TableHeader = {
  text: string;
  value: string;
  width?: string;
  formatter?: (row: CountryDataItemRowItem, column: any, cellValue: any) => string;
}

export const MGA_REPORT_TABLE = {
  headers: [
    {
      text: 'Aggregate date',
      value: ReportTableHeaders.AGGREGATE_DATE,
      width: '150',
      formatter: (row: CountryDataItemRowItem) => formatUnixToString(row[ReportTableHeaders.AGGREGATE_DATE], true),
    },
    {
      text: 'Currency',
      value: ReportTableHeaders.CURRENCY,
    },
    {
      text: 'Game producer ID',
      value: ReportTableHeaders.GAME_PRODUCER,
      width: '160',
    },
    {
      text: 'Bets bonus sum',
      value: ReportTableHeaders.BETS_BONUS_SUM,
    },
    {
      text: 'Bets sum',
      value: ReportTableHeaders.BETS_SUM,
    },
    {
      text: 'Wins bonus sum',
      value: ReportTableHeaders.WINS_BONUS_SUM,
    },
    {
      text: 'Wins sum',
      value: ReportTableHeaders.WINS_SUM,
    },
    {
      text: 'Revenue',
      value: ReportTableHeaders.REVENUE,
    },
  ],
};

export type ReportListModel = {
  countryData: CountryDataItem[];
  total: DefaultReportModel;
}

export type CountryDataItem = {
  countryName: string;
  rows: CountryDataItemRowItem[];
  total: DefaultReportModel;
}

export type DefaultReportModel = {
  betsBonusSum: string;
  betsSum: string;
  currency: string;
  revenue: string;
  winsBonusSum: string;
  winsSum: string;
}

export type CountryDataItemRowItem = DefaultReportModel & {
  aggregateDate: number;
  gameProducer: string;
}

export type ReportListRequestModel = {
  groupByDate: GroupByDate;
  country?: string | null;
  currency?: string | null;
  gameProducerId?: string | null;
  gameType?: string | null;
  gameCategory?: string | null;
  dateFrom?: string | null;
  exchangeRateDate?: string | null;
}

export type ReportListCsvRequestModel = {
  timestamp: boolean;
  filterList: ReportListRequestModel;
  code: string | null;
}
